import {HttpModelConverter} from '../../../../../../../core/converter/httpModel.converter';
import {PaymentRequestReminderSummaryModel} from '../paymentRequestReminderSummary.model';
import {Injectable} from '@angular/core';
import {PaymentRequestSummaryConverter} from '../../../../api/entity/converter/paymentRequestSummary.converter';

@Injectable()
export class PaymentRequestReminderSummaryConverter extends HttpModelConverter<PaymentRequestReminderSummaryModel> {


    constructor(private paymentRequestSummaryConverter: PaymentRequestSummaryConverter) {
        super();
    }

    protected createInstance(): PaymentRequestReminderSummaryModel {
        return new PaymentRequestReminderSummaryModel();
    }

    protected enrichObject(result: PaymentRequestReminderSummaryModel, src: PaymentRequestReminderSummaryModel) {
        result.paymentRequest = this.paymentRequestSummaryConverter.convert(src.paymentRequest);
    }


}
